import { render, staticRenderFns } from "./staffTwoShift.vue?vue&type=template&id=6ea56970&scoped=true&"
import script from "./staffTwoShift.vue?vue&type=script&lang=js&"
export * from "./staffTwoShift.vue?vue&type=script&lang=js&"
import style0 from "./staffTwoShift.vue?vue&type=style&index=0&id=6ea56970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea56970",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
